import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/screens/four.css';

const  StudyAbroadCourses = () => {
  const [isVisible, setIsVisible] = useState(Array(8).fill(true));

  document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.test-card');
  
  // Function to check if element is in viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom >= 0
    );
  }
  
  // Function to handle scroll and show cards
  function handleScroll() {
    cards.forEach(card => {
      if (isInViewport(card)) {
        card.classList.add('visible');
      }
    });
  }
  
  // Check on load
  handleScroll();
  
  // Check on scroll
  window.addEventListener('scroll', handleScroll);
});

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const sectionElement = document.getElementById('standardized-tests-section');
      
      if (sectionElement) {
        const cards = sectionElement.querySelectorAll('.test-card');
        
        cards.forEach((card, index) => {
          const cardPosition = card.offsetTop + sectionElement.offsetTop;
          
          if (scrollPosition > cardPosition + 100) {
            setIsVisible(prev => {
              const newState = [...prev];
              newState[index] = true;
              return newState;
            });
          }
        });
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Trigger once on load
    setTimeout(handleScroll, 100);
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const standardizedTests = [
    {
      id: 1,
      title: "GRE",
      description: "Graduate Record Examination - Required for many graduate programs in the US and worldwide.",
      image: "https://assets.studies-overseas.com/GRE_Coaching_8a8cd17d11.png",
      color: "#3498db",
      path: "/gre"
    },
    {
      id: 2,
      title: "TOEFL",
      description: "Test of English as a Foreign Language - Measures your ability to use English at the university level.",
      image: "https://t4.ftcdn.net/jpg/03/23/32/63/360_F_323326385_eQMjx0LpXsMj51QQIyYiw9APERlwcrQ6.jpg",
      color: "#e74c3c",
      path: "/toefl"
    },
    {
      id: 3,
      title: "GMAT",
      description: "Graduate Management Admission Test - Required for business school and MBA programs.",
      image: "https://www.stylewithglamour.com/wp-content/uploads/2023/03/gmat-test.png",
      color: "#2ecc71",
      path: "/gmat"
    },
    {
      id: 4,
      title: "MCAT",
      description: "Medical College Admission Test - Required for medical school applications in the US and Canada.",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjBvG3x8MAhN7_EsDQ_3GdgquoYBHRvwjQ1obK6WTIL95DbW2CKvwBA3xLlvsvK3AY4Nc&usqp=CAU",
      color: "#f39c12",
      path: "/mcat"
    },
    {
      id: 5,
      title: "FMGE",
      description: "FMGE Medical Licensing Examination - Required for medical practitioners seeking licensure in the US & other countries across world.",
      image: "https://media.licdn.com/dms/image/v2/D5612AQErFtnvqs0P0w/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1718342121100?e=2147483647&v=beta&t=j_HeaIleHRYi0nKXRXYRl2D3ZVqgnyu-CKZFR_bjkZ0",
      color: "#9b59b6",
      path: "/fmge"
    },
    {
      id: 6,
      title: "SAT",
      description: "Scholastic Assessment Test - Required for undergraduate admissions in the US.",
      image: "https://edysor.in/images/exam/1702966407.jpg",
      color: "#1abc9c",
      path: "/sat"
    },
    {
      id: 7,
      title: "PTE",
      description: "Pearson Test of English - Computer-based English language test for non-native speakers.",
      image: "https://learnandtalk.ca/wp-content/uploads/2024/05/pte_diagram-1024x763.png",
      color: "#e67e22",
      path: "/pte"
    },
    {
      id: 8,
      title: "IELTS",
      description: "International English Language Testing System - Widely accepted English proficiency test worldwide.",
      image: "https://media.licdn.com/dms/image/v2/D4D12AQHEwUA-UK2Bxg/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1700659152972?e=2147483647&v=beta&t=GW9BCDK73UNC0EohqzHcD8NMILP3jy1LENEIEpRoUdU",
      color: "#16a085",
      path: "/ielts"
    }
  ];

  return (
    <section id="standardized-tests-section" className="py-5">
    <Container>
      <div className="text-center mb-5">
        <h1 className="section-title">Standardized Tests Preparation</h1>
        <p className="section-subtitle">Comprehensive preparation materials and guidance for your academic journey</p>
      </div>
      
      <Row className="test-cards-container">
        {standardizedTests.map((test, index) => (
          <Col xs={6} md={6} lg={3} key={test.id} className="mb-4">
            <Card 
              className={`test-card h-100 ${isVisible[index] ? 'visible' : ''}`}
              style={{ 
                transitionDelay: `${index * 0.1}s`,
                borderTop: `4px solid ${test.color}`
              }}
            >
              <div className="card-img-container">
                {/* Add fallback for missing images */}
                <Card.Img 
                  variant="top" 
                  src={test.image} 
                  alt={test.title}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://via.placeholder.com/150x150?text=" + test.title;
                  }}
                />
                <div className="card-overlay" style={{ backgroundColor: `${test.color}80` }}></div>
              </div>
              <Card.Body>
                <Card.Title>{test.title}</Card.Title>
                <Card.Text>{test.description}</Card.Text>
              </Card.Body>
              <Card.Footer className="bg-white border-0">
                <Link to={test.path} className="test-btn" style={{ backgroundColor: test.color }}>
                  Learn More <i className="arrow-icon">→</i>
                </Link>
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  </section>
   
  );
}

export default StudyAbroadCourses;